export default __webpack_public_path__ + "static/media/royKlein.40bb67a3.jpg";